<div *ngIf="!isClosed" class="columnSettingBlock d-flex flex-column" [class.hidden]="isClosed">
    <i class="icofont-close icon-close hand" (click)="toggleColumnSetting()"></i>
    <div class="d-flex align-items-center justify-content-end px-4 py-1 reset-filter">
        <!-- <app-svg-icon
          [src]="'./assets/SVGIcons/undoSVG.svg'"
          class="m-r-5"
          (click)="resetToDefault(true)"
        ></app-svg-icon> -->
        <app-svg
        class="m-r-5"
       (click)="resetToDefault(true)"
        iconType="UndoSVG" >                        
       </app-svg>
        <span (click)="resetToDefault(true)" class="font-12 m-t-2" type="button">Reset to Default</span>
    </div>
    <div class="column-search d-flex align-items-center my-2">
       <!-- <app-svg-icon 
       style="color: #8B9DAA;"
         [src]="'./assets/SVGIcons/searchicon.svg'"    
         class="d-flex align-items-center justify-content-center"
         >
       </app-svg-icon> -->
       <app-svg
         style="color: #8B9DAA;"
         class="d-flex align-items-center justify-content-center"
        iconType="Search" >                        
       </app-svg>
       <input
        (input)="onFilterTextBoxChanged()"
         id="filter-text-box"
         class="searched"
         type="text"
         placeholder="Search"
       />
    </div>
        <ag-grid-angular
      class="ag-theme-alpine sideColumnSetting"
      style="height: 100%"
      [columnDefs]="sideColumnDefs"
      [rowDragManaged]="true"
      [context]="dataModel?.context"
      (gridReady)="sideOnGridReady($event)"
      (rowDragEnd)="onRowDragEnd($event)"
      (rowDragLeave)="onRowDragLeave($event)"
      [icons]="icons"
      [animateRows]="true"
      [headerHeight]="0"
      [rowHeight]="35"
      [rowData]="sideRowData"
    ></ag-grid-angular>
</div>

<!-- <i class="icofont-close settings icon-settings hand" (click)="toggleColumnSetting()" *ngIf="isClosed"></i> -->
<!-- <app-svg-icon
[src]="'./assets/SVGIcons/settingIcon.svg'"
class="d-flex margin-LR clsesvg"
(click)="toggleColumnSetting()" *ngIf="isClosed"
></app-svg-icon> -->
<app-svg
class="d-flex margin-LR clsesvg"
(click)="toggleColumnSetting()" *ngIf="isClosed"
 iconType="Setting" >                        
</app-svg>